import Breadcrumb from "shared/components/navigation/breadcrumb/Breadcrumb";
import HStack from "shared/components/layout/stack/HStack";
import Icon from "shared/components/utils/Icon";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import Tooltip from "shared/components/utils/tooltip/Tooltip";
import VStack from "shared/components/layout/stack/VStack";
import {
    CompactInfoRow,
    InfoSeparator,
    ResponsivePageHeadWrapper,
    StyledListWrapper,
    StyledPageHeadTitle,
} from "./PageHead.styles";

const PageHead = ({
    title,
    description,
    menuOptions,
    listOptions,
    compact = false,
    ...rest
}) => {
    const renderListOptions = (isCompact) =>
        listOptions && (
            <StyledListWrapper $compact={isCompact}>
                {listOptions.map((data) => (
                    <Tooltip
                        text={data.text}
                        enterDelay={0}
                        placement="bottom-start"
                        key={data.name}
                    >
                        <HStack spacing="Zero_5" align="center">
                            {data.name !== "null" && (
                                <>
                                    <Icon name={data.icon} />
                                    <Text
                                        variant={isCompact ? "Body_2_1" : "Body_1_1"}
                                        color="Gray_2"
                                    >
                                        {data.name}
                                    </Text>
                                </>
                            )}
                        </HStack>
                    </Tooltip>
                ))}
            </StyledListWrapper>
        );

    return (
        <ResponsivePageHeadWrapper spacing="One" {...rest}>
            {menuOptions && <Breadcrumb menuOptions={menuOptions} />}
            <HStack justify="space-between" align="flex-end">
                <VStack spacing={compact ? "Zero_25" : "Zero_5"}>
                    {title && (
                        <StyledPageHeadTitle
                            variant={compact ? "Headline_2" : "Headline_1"}
                            color="Black"
                            $compact={compact}
                        >
                            {title}
                        </StyledPageHeadTitle>
                    )}
                    {compact ? (
                        <CompactInfoRow spacing="Zero_75" align="center">
                            {description && (
                                <Text variant="Body_2_1" color="Gray_2">
                                    {description}
                                </Text>
                            )}
                            {description && listOptions?.length > 0 && (
                                <InfoSeparator aria-hidden="true">|</InfoSeparator>
                            )}
                            {renderListOptions(true)}
                        </CompactInfoRow>
                    ) : (
                        <>
                            {description && (
                                <Text variant="Body_1_1" color="Gray_2">
                                    {description}
                                </Text>
                            )}
                            {renderListOptions(false)}
                        </>
                    )}
                </VStack>
            </HStack>
        </ResponsivePageHeadWrapper>
    );
};

PageHead.defaultProps = {
    compact: false,
};

PageHead.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    menuOptions: PropTypes.array,
    listOptions: PropTypes.array,
    compact: PropTypes.bool,
};

export default PageHead;
